import PropTypes from 'prop-types';
import React from 'react';

import { OSLO_GRAY } from '@wetransfer/transfer/constant/colors';

export default class Close extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    hoverColor: PropTypes.string,
    onClick: PropTypes.func,
    tabIndex: PropTypes.number,
    label: PropTypes.string,
  };

  static defaultProps = {
    color: OSLO_GRAY,
  };

  state = {
    hover: false,
  };

  render() {
    const { className, color, hoverColor, onClick, tabIndex, label } =
      this.props;

    const fillColor = this.state.hover && hoverColor ? hoverColor : color;

    return (
      <svg
        className={className}
        tabIndex={tabIndex}
        onMouseOut={() => this.setState({ hover: false })}
        onMouseOver={() => this.setState({ hover: true })}
        onClick={onClick}
        aria-label={label}
      >
        <path
          fillRule="evenodd"
          fill={fillColor}
          d="M5 3.15396L2.22669 0.380657C1.72851 -0.117528 0.894674 -0.124865 0.384905 0.384905C-0.128419 0.898228 -0.126767 1.71927 0.380657 2.22669L3.15396 5L0.380657 7.77331C-0.117528 8.27149 -0.124865 9.10533 0.384905 9.6151C0.898228 10.1284 1.71927 10.1268 2.22669 9.61934L5 6.84604L7.77331 9.61934C8.27149 10.1175 9.10533 10.1249 9.6151 9.6151C10.1284 9.10177 10.1268 8.28073 9.61934 7.77331L6.84604 5L9.61934 2.22669C10.1175 1.72851 10.1249 0.894674 9.6151 0.384905C9.10177 -0.128419 8.28073 -0.126767 7.77331 0.380657L5 3.15396Z"
        />
      </svg>
    );
  }
}
